export const RESTAURANT_CONFIG = "RESTAURANT_CONFIG";
export const ACTIVE_OUTLET = "ACTIVE_OUTLET";
